export const PageDashboard = (state) => ({
  dashboard: state.index.dashboard,
  isLoading: state.index.isLoading,
})
